import { styled } from '@mui/material/styles';
import { Select, SvgIcon } from '@mui/material';

export const StyledWrapperLocaleSelector = styled('div')(
  ({ theme }) => `
    display: flex;
    flex-wrap: nowrap;
    ${theme.breakpoints.up('lg')} { 
    padding-top:4px;
    &:hover {
       svg {
           path {
            stroke: ${theme.DS_palette.buttons.enabled};
           }
         }
          span {
         color: ${theme.DS_palette.buttons.enabled};
         }
      }
    }
  `,
);

export const StyledSelect = styled(Select)(
  ({ theme }) => `

  padding: 12px 0;
  &.MuiInput-root {
    width: 3rem;
    background-color: none;
      .MuiSelect-select:focus {
       background-color: transparent;
    }
  }
 
  &.MuiInput-underline::before, &.MuiInput-underline:hover::before {
   border-bottom: none;
   transition:  none;
  }
  &.MuiInput-underline::after {
   border-bottom: none;
  }
  
  svg {
    margin-top: 2px;
    margin-right: ${theme.DS_spacing(['xxs'])} ;
    width: 0.7rem;
    height: auto;

   }
  
     
  `,
);

export const StyledSvgWorldIcon = styled(SvgIcon)(
  ({ theme }) => `
     fill: none;
     margin-top: ${theme.DS_spacing(['xs'])};
     margin-right: ${theme.DS_spacing(['xs'])};
     
     ${theme.breakpoints.up('lg')} { 
       margin-left: ${theme.DS_spacing(['xs'])};
       margin-top:${theme.DS_spacing(['xs'])};
       margin-right: ${theme.DS_spacing(['xxxs'])};
       
     }
  `,
);
